export {
  IVariant as UnleashVariant,
  IContext as UnleashContext,
  IConfig as UnleashConfig,
  EVENTS,
} from 'unleash-proxy-client';
